import React from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { LINK_PRIVACIDADE_SEGURANCA, LINK_REGULAMENTO_INDICACAO_AMIGOS, LINK_TERMOS_SERVICOS, TERMOS_SERVICOS, REGULAMENTO_INDICACAO_AMIGOS, PRIVACIDADE_SEGURANCA } from './constantsTermosRegulamento'

const TermosTexto = styled.p`
  ${StyleGuide.tipografia.textoHelper};
  color: ${StyleGuide.cores.cinza500};
  margin: 22px 0 0 0;

  .link {
    color: ${StyleGuide.cores.azul};
    text-decoration: underline;
  }
`

const TermosRegulamento = ( { nomeBotao } ) => {
  return (
    <TermosTexto>
      { `Ao clicar em ${nomeBotao}, você concorda com nossos ` }
      <a
        href={ LINK_TERMOS_SERVICOS }
        onClick={ () => {
          window.open( LINK_TERMOS_SERVICOS )
          return false
        } }
        rel="noopener noreferrer"
        target="_blank"
      >
        { TERMOS_SERVICOS }
      </a>
      { ', ' }
      <a
        href={ LINK_REGULAMENTO_INDICACAO_AMIGOS }
        onClick={ () => {
          window.open( LINK_REGULAMENTO_INDICACAO_AMIGOS )
          return false
        } }
        rel="noopener noreferrer"
        target="_blank"
      >
        { REGULAMENTO_INDICACAO_AMIGOS }
      </a>
      { `, e ` }
      <a
        href={ LINK_PRIVACIDADE_SEGURANCA }
        onClick={ () => {
          window.open( LINK_PRIVACIDADE_SEGURANCA )
          return false
        } }
        rel="noopener noreferrer"
        target="_blank"
      >
        { PRIVACIDADE_SEGURANCA }
      </a> .
    </TermosTexto>
  )
}

TermosRegulamento.propTypes = {
  'nomeBotao': string.isRequired
}

export default TermosRegulamento
